import {RecoilState, RecoilValueReadOnly, SerializableParam, useRecoilValue, useSetRecoilState} from 'recoil';

interface QueryValue<T> {
  data: T;
  error: null;
  loading: false;
  refresh: VoidFunction;
}

type QuerySelector<T, R = T> = (query: T) => R;

export function createQuerySuspense<S, P extends SerializableParam>(
  query: (params: P) => RecoilValueReadOnly<S>,
  refreshProp: RecoilState<number>,
) {
  return <R = QueryValue<S>>(params: P, selector?: QuerySelector<QueryValue<S>, R>): R | QueryValue<S> => {
    const data = useRecoilValue(query(params));
    const refreshFn = useSetRecoilState(refreshProp);

    const refresh = () => refreshFn((prev) => prev + 1);

    const result: QueryValue<S> = {
      data,
      error: null,
      loading: false,
      refresh,
    };

    return selector ? selector(result) : result;
  };
}
